// Which invoice line an approval request is about (XPEN-3709).
// Two lines of one invoice can share a line number (`_view_id`, XPEN-3700). The
// server-owned `line_id` (XPEN-3659) is unique, so it is used whenever the request
// has one. When it has one but no line carries it, the lookup fails (-1): falling
// back to the number would land on another line, e.g. delete another receipt.
const requestLineId = (request) => request?.line_id ?? request?.line_item?.line_id ?? null;

export const findRequestLineIndex = (items = [], request) => {
    if (!request) return -1;
    const lineId = requestLineId(request);
    if (lineId) return items.findIndex((item) => item?.line_id === lineId);
    return items.findIndex((item) => String(item?._view_id) === String(request.line_item_view_id));
};
export const findRequestLine = (items = [], request) => {
    const index = findRequestLineIndex(items, request);
    return index >= 0 ? items[index] : undefined;
};
// The line part of the line routes (/approvals/line-item/... and
// /approvals/expense-policy-issues/line-item/...) and of the receipt cache key.
export const requestLinePathKey = (request) => request?.line_item_key ?? request?.line_item_view_id;
// Whether `item` (at `index` in ListItem) is the line the amount editor opened: by line_id
// when it has one, else by its index when known, else (old callers) by its number.
export const sameLine = (item, index, target, targetIndex) => {
    if (target?.line_id) return item?.line_id === target.line_id;
    if (Number.isInteger(targetIndex)) return index === targetIndex;
    return String(item?._view_id) === String(target?._view_id);
};
